import { createPinia } from 'pinia';

// Export the pinia instance
export const pinia = createPinia();

// Export all stores
export { useAuthStore } from './auth';
export { useModalStore } from './modal';
export { useWineStore } from './wines';
export { useCartStore } from './cart';
export { useInvoiceStore } from './invoices';
export { useOrderStore } from './orders';
export { useToastStore } from './toast';
export { useUIStore } from './ui';

export default pinia; 
